import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'components/icon';
import { scrollToBlock } from '../../js/scroll-utils';

const TARGET_BLOCK_ID = 'page-content';

const GoToPageContent = ({ className, ariaLabel }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const onGoToPageContentClick = e => {
    e.preventDefault();

    scrollToBlock(document.getElementById(TARGET_BLOCK_ID), true);
  };

  return (
    <a
      href={`#${TARGET_BLOCK_ID}`}
      className={cn('go-to-page-content', {
        'go-to-page-content_hidden': isScrolled,
        [className]: className,
      })}
      aria-label={ariaLabel}
      onClick={onGoToPageContentClick}
    >
      <Icon name="arrow-down" className="go-to-page-content__icon" />
    </a>
  );
};

GoToPageContent.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
};

GoToPageContent.viewModelMeta = 'ignore';

export default GoToPageContent;
